/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/lib/Async';
import RCSlider from 'rc-slider';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col } from 'react-flexgrid';
import * as Icon from 'react-feather';
import fetchGraphql from '../../core/fetchGraphql';
import s from './Collaborations.scss';
import Widget from '../../components/Widget';
import PartnersPayment from './PartnersPayment';
import ProductAdditionalExpenses from './ProductAdditionalExpenses';

const roundTo = require('round-to');
const commafy = require('commafy');

const { createSliderWithTooltip } = RCSlider;
const Slider = createSliderWithTooltip(RCSlider);

class Collaborations extends React.Component {
    static contextTypes = {
        store: PropTypes.shape(),
    };

    constructor(props) {
        super(props);

        this.state = {
            partnersPayments: [],
            partnersPaymentsOpenedItem: {},
            newPartnerPayments: '',

            collaborations: [],
            collaborationsOpenedItem: {},
            newCollaborationShowed: false,
            newCollaborationCreating: false,
            newCollaborationResponse: '',
            newCollaborationItem: '',
            newCollaborationPartner: '',
            newCollaborationPart: 50,
        };
    }

    componentDidMount() {
        const socket = this.context.store.getState().socket;

        // fetch collaborations.
        socket.on('collaborations loaded', ({ data }) => {
            this.setState({
                collaborations: data,
            });
        });
        socket.emit('collaborations fetch');

        // fetch partners payments.
        socket.on('partners payments loaded', ({ data }) => {
            this.setState({
                partnersPayments: data,
            });
        });
        socket.emit('partners payments fetch');
    }

    componentWillUnmount() {
        const socket = this.context.store.getState().socket;
        socket.emit('collaborations stop');
        socket.emit('partners payments stop');
    }

    getItems(input) {
        return fetchGraphql(`
            {
              user_products (search: "${input}") {
                item_id
                name
                thumbnail
              }
            }`)
            .then(data => data.user_products.map((item, i) => ({
                value: item.name,
                item_id: item.item_id,
                label: (<span>
                    <img className={s.selectImg} src={item.thumbnail} alt="" />
                    {' '}
                    {item.name}
                </span>),
                thumbnail: item.thumbnail,
            })));
    }

    getUsers(input, callback) {
        if (!input || input.length < 2) {
            callback([]);
            return;
        }

        clearTimeout(this.getUsersTimeout);
        this.getUsersTimeout = setTimeout(() => {
            fetchGraphql(`
                {
                  users (search: "${input}") {
                    username
                    image
                  }
                }`)
                .then((data) => {
                    callback(data.users.map((item, i) => ({
                        value: item.username,
                        label: (<span>
                            <img className={s.selectImg} src={item.image} alt="" />
                            {` ${item.username}`}
                                </span>),
                        image: item.image,
                    })));
                });
        }, 500);
    }

    createCollaboration() {
        if (this.state.newCollaborationCreating || !this.state.newCollaborationItem || !this.state.newCollaborationItem.item_id || !this.state.newCollaborationPartner || !this.state.newCollaborationPartner.value || !this.state.newCollaborationPart) {
            return;
        }

        const socket = this.context.store.getState().socket;
        const data = {
            item_id: this.state.newCollaborationItem.item_id,
            partner: this.state.newCollaborationPartner.value,
            part: this.state.newCollaborationPart,
        };

        // create collaboration.
        this.setState({
            newCollaborationCreating: true,
        });
        socket.emit('collaboration create', data, ({ data }) => {
            this.setState({
                newCollaborationCreating: false,
            });

            if (!data || data.error) {
                this.setState({
                    newCollaborationResponse: (<div className={s.responseError}>{data ? data.response : 'Something wen\'t wrong.'}</div>),
                });
            } else if (data && data.response) {
                this.setState({
                    newCollaborationResponse: (<div className={s.response}>{data.response}</div>),
                    newCollaborationItem: '',
                    newCollaborationPartner: '',
                    newCollaborationPart: 50,
                });
                socket.emit('collaborations fetch');
                socket.emit('partners payments fetch');
            }
        });
    }

    stopCollaboration(item) {
        const stopCollaboration = confirm(`Do you really want to stop collaboration with ${item.partner.name} for product "${item.product.name}"?`);
        const socket = this.context.store.getState().socket;

        if (stopCollaboration) {
            socket.emit('collaboration stop', item, () => {
                socket.emit('collaborations fetch');
                socket.emit('partners payments fetch');
            });

            const newCollaboration = this.state.collaborations.filter($this => $this.id !== item.id);

            this.setState({
                collaborations: newCollaboration,
            });
        }
    }

    render() {
        return (
            <div className={s.root}>
                {this.state.partnersPayments && this.state.partnersPayments.length
                    ? (
                        <Widget title="Payments">
                            <div className={s.listPartners}>
                                {this.state.partnersPayments.map((item, i) => {
                                    const you_pay_to_partner = item.should_pay < 0;

                                    // round
                                    let should_pay = roundTo(item.should_pay, 2);
                                    should_pay = `$${commafy(Math.abs(should_pay))}`;

                                    const title = you_pay_to_partner
                                        ? `You should pay ${should_pay} to ${item.partner.name}`
                                        : `${item.partner.name} should pay ${should_pay} to you`;

                                    const showAdditional = this.state.partnersPaymentsOpenedItem[i];

                                    return (
                                        <div key={i} title={title} onClick={() => { this.setState({ partnersPaymentsOpenedItem: { [i]: !showAdditional } }); }}>
                                            <div className={s.listPartnersPay}>{should_pay}</div>
                                            <div className={`${s.listPartnersTo} ${you_pay_to_partner ? s.listPartnersToRight : s.listPartnersToLeft}`}>
                                                { you_pay_to_partner ? (
                                                    <Icon.ArrowRight size="18" />
                                                ) : (
                                                    <Icon.ArrowLeft size="18" />
                                                )}
                                            </div>
                                            <div className={s.listPartnersAvatar}><img src={item.partner.image} alt={item.partner.name} title={item.partner.name} /></div>
                                            <div className={s.listArrow + (showAdditional ? ` ${s.listArrowUp}` : '')} />
                                            {showAdditional ? (
                                                <PartnersPayment
                                                    item={item}
                                                    onSubmit={() => {
                                                        this.context.store.getState().socket.emit('partners payments fetch');
                                                    }
                                                    }
                                                />
                                            ) : ''}
                                        </div>
                                    );
                                })}
                            </div>
                        </Widget>
                    )
                    : ''}

                {this.state.collaborations && this.state.collaborations.length
                    ? (
                        <Widget title="Products">
                            <div className={s.listCollaborations}>
                                {this.state.collaborations.map((item, i) => {
                                    const showAdditional = this.state.collaborationsOpenedItem[item.id];
                                    return (
                                        <div key={i} onClick={() => { this.setState({ collaborationsOpenedItem: { [item.id]: !showAdditional } }); }}>
                                            <div className={s.listCollaborationsPart}>
                                                {item.part}
%
                                            </div>
                                            <div className={s.listCollaborationsProduct}>
                                                <img src={item.product.thumbnail} alt={item.product.name} title={item.product.name} />
                                            </div>
                                            <div className={s.listCollaborationsProductTitle}>
                                                <span>{item.product.name}</span>
                                                <div className={s.listCollaborationsPartners}>
                                                    <div>
                                                        <img src={item.head_partner.image} alt={item.head_partner.name} title={item.head_partner.name} />
                                                    </div>
                                                    <Icon.ArrowRight size="10" />
                                                    <div>
                                                        <img src={item.partner.image} alt={item.partner.name} title={item.partner.name} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={s.listArrow + (showAdditional ? ` ${s.listArrowUp}` : '')} />
                                            {showAdditional
                                                ? (
                                                    <div className={s.listCollaborationsAdditional} onClick={(e) => { e.stopPropagation(); }}>
                                                        {showAdditional ? (
                                                            <ProductAdditionalExpenses
                                                                item={item}
                                                                onSubmit={() => {
                                                                    this.context.store.getState().socket.emit('collaborations fetch');
                                                                    this.context.store.getState().socket.emit('partners payments fetch');
                                                                }}
                                                            />
                                                        ) : ''}
                                                        <a
                                                            href="#"
                                                            className={s.listCollaborationsStop}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.stopCollaboration(item);
                                                            }}
                                                        >
Stop Collaboration
                                                        </a>
                                                    </div>
                                                ) : ''}
                                        </div>
                                    );
                                })}
                            </div>
                        </Widget>
                    )
                    : '' }


                {!this.state.newCollaborationShowed
                    ? (
                        <div
                            className={s.addCollaborationToggler}
                            onClick={() => {
                                this.setState({ newCollaborationShowed: true });
                            }}
                        >
                            <Icon.PlusCircle size="25" />
                        </div>
                    )
                    : (
                        <Widget title="Add collaboration">
                            <div className={s.addCollaboration}>
                                {this.state.newCollaborationResponse}

                                <Row>
                                    <Col md={6}>
                                        <label>Your Item</label>
                                        <AsyncSelect
                                            name="item"
                                            loadOptions={this.getItems.bind(this)}
                                            onChange={(newCollaborationItem) => {
                                                this.setState({ newCollaborationItem });
                                            }}
                                            value={this.state.newCollaborationItem}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <label>Partner Username</label>
                                        <AsyncSelect
                                            name="user"
                                            loadOptions={this.getUsers.bind(this)}
                                            onChange={(newCollaborationPartner) => {
                                                this.setState({ newCollaborationPartner });
                                            }}
                                            value={this.state.newCollaborationPartner}
                                        />
                                    </Col>
                                </Row>

                                <div>
                                    <label>Partner Part</label>
                                    <Slider
                                        min={0}
                                        max={100}
                                        tipFormatter={value => `${value}%`}
                                        value={this.state.newCollaborationPart}
                                        onChange={(newCollaborationPart) => {
                                            this.setState({ newCollaborationPart });
                                        }}
                                    />
                                </div>

                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.createCollaboration();
                                    }}
                                    className={s.btn}
                                    disabled={this.state.newCollaborationCreating || !this.state.newCollaborationItem || !this.state.newCollaborationPartner || !this.state.newCollaborationPart}
                                >
                                Create Collaboration
                                    {this.state.newCollaborationCreating ? (
                                        <span className="spinner Select-loading" />
                                    ) : ''}
                                </a>
                            </div>
                        </Widget>
                    )

                }
            </div>
        );
    }
}

export default withStyles(s)(Collaborations);
